import React, { useState } from "react";

const SubscribeNewsletter = () => {
  // State to hold the input value
  const [email, setEmail] = useState("");

  // Handler to update the state with the input's value
  const handleInputChange = (event) => {
    setEmail(event.target.value);
  };

  return (
    <article className="creatyea-padding highlighted-section subscribe-newsletter d-flex flex-column align-items-center justify-content-center padding-block-35px">
      <div className="container-fluid">
        <form
          name="subscribe_to_newsletter_form"
          action="/subscribe_to_newsletter"
          method="post"
        >
          <input type="hidden" name="authenticity_token" autoComplete="off" />
          <h4>Subscribe to our newsletter to get the latest news</h4>
          <div className="subscribe-newsletter-form-group">
            {/* Updated input field */}
            <input
              type="text"
              name="subscribe_email"
              id="subscribe_email"
              value={email} // Set the value to the state
              onChange={handleInputChange} // Update the state on change
              placeholder="Enter your Email ID"
            />
            <button type="submit" name="button" className="btn btn-primary">
              Subscribe
            </button>
          </div>
          <div id="subscription_status"></div>
        </form>
      </div>
    </article>
  );
};

export default SubscribeNewsletter;
